var _circle, _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6955,
    cy: 23.3044,
    r: 23.3044,
    fill: "#EFF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8665 33.0827H16.8952C14.7471 33.0827 13 31.4644 13 29.4748V15.6078C13 13.6183 14.7471 12 16.8952 12H31.8665C34.0145 12 35.7617 13.6183 35.7617 15.6078V29.4748C35.7614 31.4642 34.0143 33.0825 31.8663 33.0825L31.8665 33.0827ZM16.8952 13.4431C15.6064 13.4431 14.5581 14.4142 14.5581 15.6078V29.4748C14.5581 30.6685 15.6064 31.6395 16.8952 31.6395H31.8665C33.1552 31.6395 34.2036 30.6685 34.2036 29.4748V15.6078C34.2036 14.4142 33.1552 13.4431 31.8665 13.4431H16.8952Z",
    fill: "#2176FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2996 17.7172C26.2996 19.1623 25.0348 20.3339 23.4745 20.3339C21.9142 20.3339 20.6494 19.1624 20.6494 17.7172C20.6494 16.272 21.9142 15.1004 23.4745 15.1004C25.0348 15.1004 26.2996 16.272 26.2996 17.7172Z",
    fill: "#FFCA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6493 28.6132H19.6494V25.5987C19.6494 23.0294 21.1415 20.9466 22.982 20.9466H24.3168C26.1573 20.9466 27.6494 23.0294 27.6494 25.5987C27.6492 25.5987 27.6492 28.6132 27.6492 28.6132H27.6493Z",
    fill: "#2176FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 27.2917,
    width: 8,
    height: 1.91667,
    fill: "#FFCA00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.84505db2cefdbcbe4df5be1e6f14233c.svg";
export { ForwardRef as ReactComponent };